(function () {
  if (window.IPQuizAnalytics) return;

  var EVENT_MAP = {
    quiz_started:        { meta: 'QuizStarted',        klaviyo: 'Quiz Started' },
    quiz_step_answered:  { meta: 'QuizStepAnswered',   klaviyo: 'Quiz Step Answered' },
    quiz_completed:      { meta: 'QuizCompleted',      klaviyo: 'Quiz Completed' },
    quiz_result_clicked: { meta: 'QuizResultClicked',  klaviyo: 'Quiz Result Clicked' }
  };

  function genId() {
    try {
      if (window.crypto && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    } catch (e) {}
    return 'ipq-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function sessionKey(quizId) { return 'ip_quiz_' + quizId + '_session'; }

  function getOrCreateSession(quizId, forceNew) {
    try {
      if (forceNew) {
        var fresh = genId();
        sessionStorage.setItem(sessionKey(quizId), fresh);
        return fresh;
      }
      var existing = sessionStorage.getItem(sessionKey(quizId));
      if (existing) return existing;
      var sid = genId();
      sessionStorage.setItem(sessionKey(quizId), sid);
      return sid;
    } catch (e) {
      return genId();
    }
  }

  function clearSession(quizId) {
    try { sessionStorage.removeItem(sessionKey(quizId)); } catch (e) {}
  }

  function consentAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed();
      }
    } catch (e) {}
    return true;
  }

  function flatten(answers, prefix) {
    var out = {};
    if (!answers) return out;
    Object.keys(answers).forEach(function (k) {
      var v = answers[k];
      if (v == null) return;
      out[(prefix || 'answer_') + k] = String(v);
    });
    return out;
  }

  function dispatch(internalName, props) {
    if (!consentAllowed()) return;
    var safeProps = props || {};
    var meta = EVENT_MAP[internalName] || {};

    try { window.gtag && window.gtag('event', internalName, safeProps); } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      var dlPayload = { event: internalName };
      Object.keys(safeProps).forEach(function (k) { dlPayload[k] = safeProps[k]; });
      window.dataLayer.push(dlPayload);
    } catch (e) {}
    try { meta.meta && window.fbq && window.fbq('trackCustom', meta.meta, safeProps); } catch (e) {}
    try { meta.klaviyo && window._learnq && window._learnq.push(['track', meta.klaviyo, safeProps]); } catch (e) {}
    try { window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish && window.Shopify.analytics.publish(internalName, safeProps); } catch (e) {}
  }

  window.IPQuizAnalytics = {
    start: function (opts) {
      opts = opts || {};
      var quizId = opts.quiz_id;
      if (!quizId) return;
      var sid = getOrCreateSession(quizId, true);
      dispatch('quiz_started', {
        quiz_id: quizId,
        session_id: sid,
        total_steps: Number(opts.total_steps) || 0
      });
    },
    answer: function (opts) {
      opts = opts || {};
      var quizId = opts.quiz_id;
      if (!quizId) return;
      dispatch('quiz_step_answered', {
        quiz_id: quizId,
        session_id: getOrCreateSession(quizId, false),
        question: String(opts.question || ''),
        answer: String(opts.answer || ''),
        step_index: Number(opts.step_index) || 0,
        total_steps: Number(opts.total_steps) || 0
      });
    },
    complete: function (opts) {
      opts = opts || {};
      var quizId = opts.quiz_id;
      if (!quizId) return;
      var props = {
        quiz_id: quizId,
        session_id: getOrCreateSession(quizId, false),
        recommended_count: Number(opts.recommended_count) || 0
      };
      var flat = flatten(opts.answers, 'answer_');
      Object.keys(flat).forEach(function (k) { props[k] = flat[k]; });
      dispatch('quiz_completed', props);
    },
    resultClick: function (opts) {
      opts = opts || {};
      var quizId = opts.quiz_id;
      if (!quizId) return;
      var props = {
        quiz_id: quizId,
        session_id: getOrCreateSession(quizId, false),
        product_handle: String(opts.product_handle || ''),
        product_position: Number(opts.product_position) || 0
      };
      var flat = flatten(opts.answers, 'answer_');
      Object.keys(flat).forEach(function (k) { props[k] = flat[k]; });
      dispatch('quiz_result_clicked', props);
    },
    _resetSession: clearSession
  };
})();
